import React, { useMemo } from "react";
import { statusStyles } from "./data";

/**
 * Tabs are derived from the statuses actually present rather than a fixed
 * list, so whatever leadScoreLabel values the API returns are filterable and
 * no tab sits permanently at zero.
 */
export default function FilterTabs({ conversations, active, onChange }) {
  const tabs = useMemo(() => {
    const counts = new Map();

    conversations.forEach((conversation) => {
      if (!conversation.status) return;
      counts.set(conversation.status, (counts.get(conversation.status) || 0) + 1);
    });

    return [
      { label: "All", count: conversations.length },
      ...[...counts.entries()]
        // Busiest first, then alphabetical so the order is stable.
        .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
        .map(([label, count]) => ({ label, count })),
    ];
  }, [conversations]);

  return (
    <div className="conv-filter-tabs">
      {tabs.map((tab) => {
        const dotColor =
          tab.label === "All" ? null : statusStyles[tab.label]?.dot;

        return (
          <button
            type="button"
            key={tab.label}
            className={`conv-filter-tab${active === tab.label ? " is-active" : ""}`}
            onClick={() => onChange(tab.label)}
          >
            {dotColor && (
              <span
                className="conv-filter-dot"
                style={{ background: dotColor }}
              />
            )}
            {tab.label}
            <span className="conv-filter-count">{tab.count}</span>
          </button>
        );
      })}
    </div>
  );
}
